import { RichTreeView, type TreeViewBaseItem } from '@mui/x-tree-view';
import type { RichTreeViewApiRef } from '@mui/x-tree-view/RichTreeView/RichTreeView.types';
import { CustomTreeItem, type TreeItemWithIcon } from './CustomTreeItem';

interface TreeSelectContentProps {
  items: TreeViewBaseItem<TreeItemWithIcon>[];
  selectedItems: string[];
  defaultExpandedItems: string[];
  expandedItems: string[];
  onExpandedItemsChange: (event: React.SyntheticEvent, ids: string[]) => void;
  apiRef: RichTreeViewApiRef;
  onSelectedItemsChange: (event: React.SyntheticEvent, ids: string[]) => void;
  onItemSelectionToggle: (event: React.SyntheticEvent, itemId: string, isSelected: boolean) => void;
  onItemClick: (event: React.MouseEvent, itemId: string) => void;
}

export function TreeSelectContent({
  items,
  selectedItems,
  defaultExpandedItems,
  expandedItems,
  onExpandedItemsChange,
  apiRef,
  onSelectedItemsChange,
  onItemSelectionToggle,
  onItemClick,
}: TreeSelectContentProps) {
  return (
    <RichTreeView
      multiSelect
      defaultExpandedItems={defaultExpandedItems}
      expandedItems={expandedItems}
      onExpandedItemsChange={onExpandedItemsChange}
      apiRef={apiRef}
      checkboxSelection
      selectedItems={selectedItems}
      items={items}
      slots={{ item: CustomTreeItem }}
      onSelectedItemsChange={onSelectedItemsChange}
      onItemSelectionToggle={onItemSelectionToggle}
      onItemClick={onItemClick}
      sx={{
        fontSize: '14px',
        '& .MuiTreeItem2-label': {
          fontSize: '14px',
        },
      }}
    />
  );
}
